import { useCallback } from "react";
import { type Location, useLocation, useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants/routes";

interface AuthLocationState {
  from?: Location;
}

export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as AuthLocationState | null)?.from;

  const redirectAfterAuth = useCallback(() => {
    if (from) {
      navigate(from, { replace: true, state: from.state });
      return;
    }
    navigate(ROUTES.CREATE, { replace: true });
  }, [navigate, from]);

  return { redirectAfterAuth };
};
